import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "toggleBtn", "openBtn", "headerBar"]

  fillSuggestion(event) {
    const suggestion = event.currentTarget.dataset.suggestion
    const input = document.getElementById('chat-input')
    if (input) {
      input.value = suggestion
      input.focus()
      const form = input.closest('form')
      if (form) form.requestSubmit()
    }
  }

  toggleSidebar() {
    if (!this.hasSidebarTarget) return
    const sidebar = this.sidebarTarget
    const isOpen = sidebar.style.width !== '0px'

    if (isOpen) {
      sidebar.style.width = '0px'
      sidebar.style.minWidth = '0px'
      sidebar.style.overflow = 'hidden'
      if (this.hasHeaderBarTarget) {
        this.headerBarTarget.classList.remove('hidden')
        this.headerBarTarget.classList.add('flex')
      }
    } else {
      sidebar.style.width = '260px'
      sidebar.style.minWidth = ''
      sidebar.style.overflow = ''
      if (this.hasHeaderBarTarget) {
        this.headerBarTarget.classList.add('hidden')
        this.headerBarTarget.classList.remove('flex')
      }
    }
  }

  handleKeydown(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      const form = event.target.closest('form')
      if (form) form.requestSubmit()
    }
  }
}
